import React, { useState } from "react";
import { Typography } from "components";
import { HiHome } from "react-icons/hi";
import { BsFillPersonFill } from "react-icons/bs";
import { BiAlarm } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import { pocketMoniUrl, ROUTES } from "routes/routePaths";
import { permissions } from "utils/permissions";
import { IoIosPeople } from "react-icons/io";
import { IoLogOut } from "react-icons/io5";
import { HiChartSquareBar } from "react-icons/hi";
import { AiFillSetting } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  RiBarChartHorizontalLine,
  RiQuestionFill,
  RiOrganizationChart,
} from "react-icons/ri";
import { BsCheckSquareFill } from "react-icons/bs";
import { MdOutlineClose, MdOutlineKeyboardArrowDown } from "react-icons/md";
import pocketMoniLogo from "assets/images/pocketmoni-logo.png";
import {
  logOut,
  hasPermission,
  isAdminUser,
  isAggregatorUser,
  isUserActive,
  isAgentUser,
} from "utils/helper";
import "./style.scss";

const SidebarLinks = (props) => {
  const [hoveredLink, setHoveredLink] = useState(null);
  const [activeNested, setActiveNested] = useState(null);

  const user = useSelector((state) => state.user);
  const userAuthorities = user?.user?.authorities;

  const navigate = useNavigate();
  const location = useLocation();

  const {
    dashboard,
    dashboardOnboardingStats,
    dashboardTerminalStats,
    registerTerminal,
    terminalRequests,
    manageTerminals,
    manageRoles,
    manageUsers,
    manageAgents,
    terminals,
    pendingKYCs,
    validatedKYCs,
    agentManagement,
    adminAccounts,
    terminalsAuthorization,
    rolesAuthorization,
    terminalsMappingApproval,
    userProfile,
    manageNotifications,
    reports,
    transactions,
    passwordSetting,
    pmAccountsApproval,
    finalApproval,
  } = ROUTES;

  const {
    canSeeApproveAgentAccount,
    canSeeApproveAgent,
    canSeeApproveAdminAccount,
    canSeeApproveRoleAuthorization,
    canSeeApproveTerminalAuthorization,
    canSeeApproveTerminalMapping,
    canSeeUserManagementAdmin, //meaning
    // canSeeAdminUserManagement,
    canSeeUserManagement,
    canSeeRoleManagemnt,
    canSeeTerminalRequests,
    canSeeRegisterTerminals,
    canSeeManageTerminals,
    canSeeTerminals,
    canSeeAgentManagement,
    canSeeNotificationManagement,
    canSeeOnboardingStaistics,
    canSeeTerminalStaistics,
    canSeeTransactionReport,
    canSeeApprovePmAccountLevelOne,
    canSeeApprovePmAccountLevelTwo,
  } = permissions;

  const appLinks = [
    {
      icon: <BsCheckSquareFill fontSize="16px" />,
      label: "Approvals",
      canView: [],
      nestedLinks: [
        {
          label: "Agents Accounts",
          link: pendingKYCs,
          canView: canSeeApproveAgentAccount,
        },
        {
          label: "Agents Approval",
          link: validatedKYCs,
          canView: canSeeApproveAgent,
        },
        {
          label: "PM Accounts Added",
          link: pmAccountsApproval,
          canView: canSeeApprovePmAccountLevelOne,
        },
        {
          label: "PM Final Approval",
          link: finalApproval,
          canView: canSeeApprovePmAccountLevelTwo,
        },
        {
          label: "User Accounts",
          link: adminAccounts,
          canView: canSeeApproveAdminAccount,
        },
        {
          label: "Roles Authorization",
          link: rolesAuthorization,
          canView: canSeeApproveRoleAuthorization,
        },
        {
          label: "Terminals Authorization",
          link: terminalsAuthorization,
          canView: canSeeApproveTerminalAuthorization,
        },
        {
          label: "Terminals Mapping",
          link: terminalsMappingApproval,
          canView: canSeeApproveTerminalMapping,
        },
      ],
    },
    {
      icon: <IoIosPeople />,
      label: "User Management",
      link: manageUsers,
      canView: canSeeUserManagementAdmin,
    },
    {
      icon: <IoIosPeople />,
      label: "Agent Management",
      link: manageAgents,
      canView: canSeeUserManagement,
    },
    {
      icon: <BsFillPersonFill />,
      label: "Transactions",
      link: transactions,
      canView: canSeeTransactionReport,
    },
    {
      icon: <RiOrganizationChart />,
      label: "Role Management",
      link: manageRoles,
      canView: canSeeRoleManagemnt,
    },
    {
      icon: <RiBarChartHorizontalLine />,
      label: "Terminals",
      link: "",
      canView: [],
      nestedLinks: [
        {
          label: "Terminal Requests",
          link: terminalRequests,
          canView: canSeeTerminalRequests,
        },
        {
          label: "Register Terminals",
          link: registerTerminal,
          canView: canSeeRegisterTerminals,
        },
        {
          label: "Manage Terminals",
          link: manageTerminals,
          canView: canSeeManageTerminals,
        },
      ],
    },

    {
      icon: <BiAlarm />,
      label: "Notifications",
      link: manageNotifications,
      canView: canSeeNotificationManagement,
    },
    {
      icon: <RiBarChartHorizontalLine />,
      label: "My Terminals",
      link: terminals,
      canView: canSeeTerminals,
    },
    {
      icon: <HiChartSquareBar />,
      label: "Reporting",
      link: reports,
    },
    {
      icon: <IoIosPeople />,
      label: "Agent Management",
      link: agentManagement,
      canView: canSeeAgentManagement,
    },

    {
      icon: <BsFillPersonFill />,
      label: "My Profile",
      link: userProfile,
    },
    {
      icon: <AiFillSetting />,
      label: "Settings",
      link: passwordSetting,
    },
    {
      icon: <RiQuestionFill />,
      label: "FAQs",
      link: "",
      hideOnDesktop: true,
    },
  ];

  // hasPermission(
  //   permissions.canSeeOnboardingStaistics,
  //   currentUser.authorities
  // )

  const getUserLinks = () => {
    let dashboardLink = {
      icon: <HiHome />,
      label: "Dashboard",
      link: dashboard,
      canView: [],
    };

    const currentUser = user?.user;
    const linkWithMulti = {
      icon: <HiHome />,
      label: "Dashboard",
      link: null,
      nestedLinks: [
        {
          label: "Terminal Statistics",
          link: dashboardTerminalStats,
          canView: canSeeTerminalStaistics,
        },
        {
          label: "Onboarding Statistics",
          link: dashboardOnboardingStats,
          canView: canSeeOnboardingStaistics,
        },
      ],
    };

    if (
      isAdminUser(currentUser) ||
      (isAggregatorUser(currentUser) && isUserActive(currentUser.status))
    ) {
      dashboardLink = linkWithMulti;
    } else if (isAgentUser(currentUser) && isUserActive(currentUser.status)) {
      dashboardLink = {
        icon: <HiHome />,
        label: "Dashboard",
        link: dashboardTerminalStats,
        canView: canSeeTerminalStaistics,
      };
    }

    return [dashboardLink, ...appLinks];
  };

  const linksToDisplay =
    user?.user?.status === 1 ? getUserLinks() : [getUserLinks()[0]];

  const getLinkStatus = (id, link) =>
    hoveredLink === id || location.pathname === link;

  const getTypographyState = (id, link) => {
    if (!props.isSmallScreen) {
      return getLinkStatus(id, link) ? "primary" : "tetiary";
    } else {
      return getLinkStatus(id, link) ? "tetiary" : "default";
    }
  };

  const handleLinkClick = (id, link) => {
    link && navigate(link);
    activeNested !== id ? setActiveNested(id) : setActiveNested(null);
  };

  const noPermissionLinks = [dashboard, userProfile, reports, passwordSetting];

  // const shouldRender = () => true;
  const shouldRender = (permission, link, nestedLinks) => {
    //check if the link is dashboard, we open up

    if (noPermissionLinks.includes(link) || link === null) return true;

    //Each item on the sidebar can have nested links or not
    //If it has nested links, we render the item based on a condition that the user has an authority to view any of the nested links
    if (nestedLinks) {
      return !!nestedLinks.find(({ canView }) =>
        userAuthorities.includes(canView)
      );
    }

    //In this case, no nested links
    //Otherwise, check is user has the authority to access the link

    return hasPermission(permission, userAuthorities);
  };

  return (
    <div className="sidebar-container h-100">
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          <Typography
            variant="body4"
            state="tetiary"
            className="user-type d-none d-lg-block"
          >
            {/* {getUserType(user)} */}
          </Typography>
          <div className="d-block d-lg-none mt-4 mobile-menu">
            <div className="close-icon-container">
              <span onClick={props.handleClose}>
                <MdOutlineClose />
              </span>
            </div>
            <a href={pocketMoniUrl} target="_blank" rel="noopener noreferrer">
              <img src={pocketMoniLogo} alt="PocketMoni" width="110" />
            </a>{" "}
          </div>
          <ul className="primary-content">
            {linksToDisplay.map(
              (
                { link, label, icon, hideOnDesktop, nestedLinks, canView },
                id
              ) =>
                shouldRender(canView, link, nestedLinks) && (
                  <li key={id}>
                    <div
                      onClick={() => handleLinkClick(id, link)}
                      className={`d-flex ${
                        hideOnDesktop ? "d-lg-none" : ""
                      } justify-content-between link-container`}
                      onMouseOver={() => {
                        setHoveredLink(id);
                      }}
                      onMouseOut={() => setHoveredLink(null)}
                    >
                      <div
                        className={`active-container ${
                          getLinkStatus(id, link)
                            ? "active-container--active"
                            : ""
                        }`}
                      ></div>
                      <div
                        className={`d-flex justify-content-between nav-link-container d-flex align-items-center ${
                          getLinkStatus(id, link)
                            ? "nav-link-container--active"
                            : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <span>{icon} </span>
                          &nbsp;
                          <Typography
                            variant="body2"
                            state={getTypographyState(id, link)}
                          >
                            {label}
                          </Typography>
                        </div>

                        {nestedLinks && (
                          <MdOutlineKeyboardArrowDown fontSize="24px" />
                        )}
                      </div>
                    </div>
                    {nestedLinks && activeNested === id && (
                      <ul className="nested-links-container">
                        {nestedLinks.map(({ label, link, canView }, index) => {
                          let key = `${label}-${index}`;
                          return (
                            shouldRender(canView, link) && (
                              <li
                                key={key}
                                className={`nested-link ${
                                  hoveredLink === key ||
                                  location.pathname === link
                                    ? "nested-link--active"
                                    : ""
                                }`}
                                onClick={() => {
                                  navigate(link);
                                  props.handleClose();
                                }}
                              >
                                <Typography
                                  variant="caption1"
                                  state={getTypographyState(key, link)}
                                  onMouseOver={() => {
                                    setHoveredLink(key);
                                  }}
                                  onMouseOut={() => setHoveredLink(null)}
                                >
                                  {label}
                                </Typography>
                              </li>
                            )
                          );
                        })}
                      </ul>
                    )}
                  </li>
                )
            )}
            <div
              className="logout-mobile d-flex align-items-center d-lg-none cursor-pointer"
              onClick={logOut}
            >
              <IoLogOut fontSize="22px" className="font-danger" /> &nbsp;
              <Typography variant="body4" className="font-danger">
                Logout
              </Typography>
            </div>
          </ul>
        </div>

        <ul className="desktop-secondary-content d-none d-md-block">
          {/* <li>
            {" "}
            <Typography variant="body4" state="tetiary">
              <span>
                <RiQuestionFill />
              </span>{" "}
              &nbsp; Faqs
            </Typography>
          </li> */}
          <li onClick={logOut}>
            <Typography variant="body4" state="tetiary">
              <span>
                <IoLogOut />
              </span>{" "}
              &nbsp;Logout
            </Typography>
          </li>
        </ul>

        <div className="d-block d-lg-none mx-auto mb-4 text-center">
          <Typography>{user?.user?.firstname}</Typography>
          <Typography variant="body4" state="primary">
            {/* Agent */}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default SidebarLinks;
